import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.25 0c1.762 0 3.309 1.16 3.867 2.75h1.633A2.77 2.77 0 0 1 16.5 5.5v13.75A2.74 2.74 0 0 1 13.75 22h-11A2.715 2.715 0 0 1 0 19.25V5.5a2.74 2.74 0 0 1 2.75-2.75h1.59A4.15 4.15 0 0 1 8.25 0m0 2.75c-.773 0-1.375.645-1.375 1.375 0 .773.602 1.375 1.375 1.375.73 0 1.375-.602 1.375-1.375 0-.73-.645-1.375-1.375-1.375m4.855 8.98h-.043c.43-.386.43-1.03 0-1.46a1.01 1.01 0 0 0-1.417 0l-4.813 4.812-2.02-2.02a.94.94 0 0 0-1.417 0 .94.94 0 0 0 0 1.418l2.75 2.75c.386.43 1.03.43 1.46 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }